export const HARVEST_PHASES = [
	'preFlowering',
	'flowering',
	'pellet',
	'expansion',
	'filling',
	'maturation',
	'harvest',
	'postHarvest',
] as const;

export type HarvestPhase = (typeof HARVEST_PHASES)[number];

export const HARVEST_PHASE_LABELS: Record<HarvestPhase, string> = {
	preFlowering: 'Pré-Florada',
	flowering: 'Florada',
	pellet: 'Chumbinho',
	expansion: 'Expansão',
	filling: 'Granação',
	maturation: 'Maturação',
	harvest: 'Colheita',
	postHarvest: 'Pós-Colheita',
};

export const HARVEST_PHASE_DESCRIPTIONS: Record<HarvestPhase, string> = {
	preFlowering: 'Fase anterior à floração da cultura',
	flowering: 'Período de florescimento das plantas',
	pellet: 'Formação dos grãos iniciais',
	expansion: 'Crescimento dos grãos',
	filling: 'Granação e desenvolvimento dos grãos',
	maturation: 'Maturação final dos grãos',
	harvest: 'Período de colheita',
	postHarvest: 'Fase posterior à colheita',
};
